<template>
  <path
    d="M16.7525 3.61548H5.7505C4.23144 3.61548 3 4.84692 3 6.36598V61.376C3 62.8951 4.23144 64.1265 5.7505 64.1265H16.7525C18.2716 64.1265 19.503 62.8951 19.503 61.376V6.36598C19.503 4.84692 18.2716 3.61548 16.7525 3.61548Z"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M3 17.3682H19.503"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M33.2556 3.61548H22.2536C20.7345 3.61548 19.5031 4.84692 19.5031 6.36598V61.376C19.5031 62.8951 20.7345 64.1265 22.2536 64.1265H33.2556C34.7746 64.1265 36.0061 62.8951 36.0061 61.376V6.36598C36.0061 4.84692 34.7746 3.61548 33.2556 3.61548Z"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M19.5031 50.374H36.0061"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M49.5992 2.71512L38.9272 5.57564C37.4537 5.9706 36.5794 7.48527 36.9743 8.95876L51.277 62.3185C51.6719 63.792 53.1866 64.6663 54.6601 64.2714L65.332 61.4108C66.8055 61.0159 67.6798 59.5012 67.2849 58.0277L52.9823 4.66797C52.5873 3.19449 51.0726 2.32016 49.5992 2.71512Z"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M48.1083 51.4742L64.0613 47.1765"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M39.5817 19.5685L55.5346 15.3052"
    :stroke="iconBorder"
    fill="transparent"
    stroke-width="5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: false,
      default: "black",
    },
    iconBorder: {
      type: String,
      required: false,
      default: "black",
    },
  },
};
</script>

<style scoped>
  path {
    font-family: var(--iconFontFamily);
    font-size: var(--iconFontSize);
    stroke:var(--iconColor)
  }
  .group:hover .group-hover\:text-hoverIcon path {
    stroke:var(--iconHoberColor)
  }
</style>